/*
*@Author: dcl
*@Description: 关于我们主页
*@Date: 2022-11-14 17:56:49
*/
<template>
<div class="a-box">
    <div class="box-title">
        <el-image class="title-img" :src="about_1" fit="cover" />
    </div>
    <div class="box-sec">
        <div class="sec-box1">
            <!-- <el-image class="box1-img" :src="about_1bg" fit="contain" /> -->
            <el-image class="box1-img2" :src="about_1bg2" fit="contain" />
            <div class="box1-point">
                <div class="point-txt">
                    <div class="txt-txt1">
                        <div class="txt1-number">6</div>大
                    </div>
                    <div class="txt-txt2">区域</div>
                </div>
                <div class="point-txt">
                    <div class="txt-txt1">
                        <div class="txt1-number">19</div>家
                    </div>
                    <div class="txt-txt2">分支机构</div>
                </div>
            </div>
            <div class="box1-con">
                <!-- <el-image class="con-img" :src="about_2" fit="contain" /> -->
                <div class="con-txt">
                    <div class="txt-title">COMPANY PROFILE</div>
                    <div class="txt-txt1">
                        <div>
                            东风南方保险代理有限公司（以下简称“东风南方保代”）成立于2016年3月30日，是一家全国性专业保险代理公司。公司位于广东省广州市花都区风神大道11号之八二楼。
                        </div>
                        <div>
                            东风南方保代为深圳市东风南方实业集团有限公司（以下简称“东风南方集团”）的全资子公司。东风南方集团是一家集汽车销售与服务、汽车金融、保险代理、二手车、进出口贸易、汽车物流、计算机软件、汽车精品、电商平台、汽车零部件、广告传媒与物业管理等事业单元的集团型企业。
                        </div>
                        <div>
                            东风南方保代总部设立六个部门，分别是财务部、行政人事部、信息技术部、集团业务部、市场业务部、合规管理部，主要负责总部业务及全国各分公司人员、财务、业务、系统的协调管理。截止至2022年10月已在华北、华中、华东、华南、西南、东北六大区域成立了19家省级分支机构，共有人员517人（含从业人员），公司总部本科及以上学历人员占比62%，高素质人力占比高。
                        </div>
                        <div>
                            东风南方保代以“合规经营、提质增效、创新发展”为经营理念，通过科技赋能，为东风南方集团、东风各主机厂及下属品牌专营店、车主提供专业保险代理服务。公司核心业务以车险、非车险、短期意外健康险为主，2022年代理保费约为15.43亿。
                        </div>
                        <div>
                            东风南方保代为广东保险中介行业协会理事单位，曾获得2019年度广东省汽车流通行业百强企业排行 年度最具影响力奖；2020年度广东省汽车流通行业百强企业排行 品牌汽车行业服务商十强；2021年度广东省汽车流通行业百强企业排行 优秀汽车金融服务商。
                        </div>
                    </div>
                    <!-- <div class="txt-txt1">公司名称：东风南方保险代理有限公司</div>
                    <div class="txt-txt1">公司地址：广州市花都区新华街风神大道8号办公楼5楼西侧</div>
                    <div class="txt-txt1">
                        经营许可证：
                        <a href="/static/img/info_3.png" target="_blank">点击查看</a>
                    </div>
                    <div class="txt-txt1">
                        中国保险行业协会信息披露访问链接：
                        <a href="http://icidp.iachina.cn/" target="_blank">http://icidp.iachina.cn/</a>
                    </div> -->
                </div>
            </div>
            <!-- <el-image class="box1-img" :src="about_3" /> -->
        </div>
        <div class="sec-box2">
            <div class="box2-title">
                <div class="title-txt">东风南方保代分支机构分布图</div>
                <div class="title-pot">至今已在华北、华中、华东、华南、西南、东北六大区域成立了19家分支机构</div>
            </div>
            <!-- <DynamicMap class="box2-echarts" /> -->
            <ChinaMap class="box2-echarts" />
            <div class="box2-txt">
                <div class="txt-num">19</div>
                <div class="txt-txt">家分支机构</div>
            </div>
            <!-- <div class="box2-echarts" ref="echarts"></div> -->
            <!-- <el-image class="box2-img" :src="home_4" />
            <div class="box2-txt">
                <div class="txt-list" v-for="(item, index) in branchList" :key="index + 'branch'">
                    <div class="list-name">{{ item.name }}</div>
                    <div class="list-li" v-for="(li, lii) in item.list" :key="lii + 'ilist'">
                        <el-image v-if="li.color === 'red'" class="li-img" :src="redPic" />
                        <el-image v-else-if="li.color === 'yellow'" class="li-img" :src="yellowPic" />
                        <el-image v-else class="li-img" :src="bluePic" />
                        <div class="li-txt">{{ li.name }}</div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="sec-box3">
            <div class="box3-title">
                <div class="title-txt">合作伙伴</div>
                <div class="title-pot">合作才能发展，共赢才是王道，我们期待您的加入</div>
            </div>
            <div class="box3-imgbox">
                <el-image class="imgbox" :src="about_9" />
                <el-image class="imgbox" :src="about_10" />
                <el-image class="imgbox" :src="about_11" />
                <el-image class="imgbox" :src="about_12" />
                <el-image class="imgbox" :src="about_13" />
                <el-image class="imgbox" :src="about_14" />
                <el-image class="imgbox" :src="about_15" />
                <el-image class="imgbox" :src="about_16" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import DynamicMap from '../../components/DynamicMap.vue'
import ChinaMap from '../../components/ChinaMap.vue'
export default {
    components: {
        DynamicMap,
        ChinaMap
    },
    data() {
        return {
            about_1: require("../../assets/about_1.jpg"),
            about_1bg: require("../../assets/about_1bg.jpg"),
            about_1bg2: require("../../assets/about_1bg2.jpg"),
            about_2: require("../../assets/about_2.jpg"),
            about_3: require("../../assets/about_3.png"),
            home_4: require("../../assets/home_4.png"),
            about_9: require("../../assets/about_9.png"),
            about_10: require("../../assets/about_10.png"),
            about_11: require("../../assets/about_11.png"),
            about_12: require("../../assets/about_12.png"),
            about_13: require("../../assets/about_13.png"),
            about_14: require("../../assets/about_14.png"),
            about_15: require("../../assets/about_15.png"),
            about_16: require("../../assets/about_16.png"),
        };
    },
};
</script>

<style lang="less" scoped>
.a-box {
    text-align: left;

    .box-title {
        // position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        // padding-bottom: 15%;
        // overflow: hidden;

        .title-img {
            width: 100%;
            height: 12.47rem;
            max-width: 1920px;
        }
    }

    .box-sec {
        margin: 0px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .sec-box1 {
            background: url('../../assets/about_1bg.jpg') no-repeat center;
            background-size: cover;
            width: 100%;
            height: 21.43rem;
            max-width: 1920px;
            margin-bottom: 1.2rem;
            position: relative;

            // .box1-img {
            //     width: 100%;
            //     height: 643px;
            // }
            .box1-img2 {
                position: absolute;
                width: 23.47rem;
                height: 16.8rem;
                top: 1.53rem;
                right: 4.23rem;
            }

            .box1-point {
                position: absolute;
                top: 8rem;
                right: 24rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background: #FF9600;
                color: #FFFFFF;
                width: 5.97rem;
                height: 11.27rem;
                font-size: 0.53rem;

                .point-txt {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 4rem;
                    margin: 1.23rem 0.47rem;
                    padding-bottom: 0.93rem;
                    border-bottom: 0.03rem solid #FFAD38;

                    .txt-txt1 {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 0.33rem;

                        .txt1-number {
                            font-size: 1.13rem;
                            margin-right: 0.2rem;
                        }
                    }
                }
            }

            .box1-con {
                position: absolute;
                top: 20px;
                // display: flex;
                // flex-direction: column;
                // align-items: center;

                .con-txt {
                    margin: 0 6.5rem .33rem;
                    // flex: 1;
                    font-size: 0.53rem;

                    .txt-title {
                        margin: 0;
                        font-size: 1.53rem;
                        color: #EFF0F2;
                        position: relative;
                        top: .835rem;
                        font-weight: bold;
                    }

                    .txt-title::before {
                        content: '东风南方保险代理有限公司';
                        font-size: 1.13rem;
                        font-weight: bold;
                        color: #636363;
                        position: absolute;
                        top: -.635rem;
                        left: 0px;
                    }

                    .txt-txt1 {
                        font-size: 0.53rem;
                        line-height: 0.8rem;
                        margin-top: .835rem;

                        div {
                            width: 21.57rem;
                            margin: .13rem 0px;
                            text-indent: 1.06rem;
                            // line-height: .8rem;
                        }
                    }
                }
            }
        }

        .sec-box2 {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: 0;
            width: 100%;

            .box2-title {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                .title-txt {
                    font-weight: bold;
                    font-size: 1.13rem;
                    color: #2387D5;
                }

                .title-pot {
                    font-size: 0.53rem;
                    margin-top: .4rem;
                    color: #aaa;
                }
            }

            .box2-echarts {
                height: 1050px;
                width: 100%;
                max-width: 1920px;
                // position: relative;
            }

            .box2-txt {
                // position: absolute;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: -200px 0 0 -500px;
                // left: 10%;
                // bottom: 30%;

                .txt-num {
                    font-size: 3rem;
                    color: #ffc72c;
                }

                .txt-txt {
                    margin-top: 1.2rem;
                    margin-left: .2rem;
                    font-size: 1.13rem;
                }
            }
        }

        .sec-box3 {
            margin-top: 2.13rem;
            max-width: 1920px;

            .box3-title {
                margin-left: 7.17rem;

                .title-txt {
                    display: flex;
                    align-items: flex-end;
                    justify-content: center;
                    font-size: 1.2rem;
                    font-weight: bold;
                    width: 5.33rem;
                    height: 1.87rem;
                    background-image: linear-gradient(#F9FAFE, #E6E6E6);
                }

                .title-pot {
                    margin-top: .4rem;
                    color: #333333;
                    font-size: 0.53rem;
                }
            }

            // .box3-img1 {
            //     width: 100%;
            //     height: 272px;
            // }

            .box3-imgbox {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-content: center;
                margin-left: 4.67rem;

                .imgbox {
                    width: 13.93rem;
                    height: 9.07rem;
                    // margin: 0px calc(4% / 8) -40px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/About/index.vue